module.exports = __webpack_public_path__ + "static/img/asiaGaming.424d9c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/footer/asiaGaming.png
// module id = BDLh
// module chunks = 3